<template>
  <div>
    <div>

      <!-- Título -->
      <div class="mt-4 text-h6 text-center">Notas por Colaborador</div>

      <!-- Tabela -->
      <v-row justify="end">
        <v-col cols="4">
          <v-text-field v-model="search" single-line clearable hide-details prepend-inner-icon="mdi-magnify"
            label="Busca" />
        </v-col>
      </v-row>

      <!-- <v-data-table dense :headers="headers" :items="operadoresDados" class="elevation-1 mb-6" hide-default-footer -->
      <v-data-table dense :search="search" :headers="headers" :items="avaliacaoGeralDados" class="elevation-1 mb-6"
        :custom-filter="buscaTodosCampos" disable-pagination hide-default-footer>
        <!-- Acrescenta caixas coloridas no cabeçalho -->
        <!-- Os slots dinâmicos do vuetify tem uma incompatibilidade com o eslint, por isso as linhas comentadas a seguir. (está na documentação do vuetify) -->
        <!-- eslint-disable-next-line -->
        <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
          <!-- eslint-disable-next-line -->
          <th style="display: inline-flex; align-items: center; justify-items: center;">
            <span v-if="header.value !== 'Total' && header.value !== 'Média' && header.value !== 'Colaborador'"
              class="tamanhoDoQuadrado" :style="{color: header.color}">&#9632;</span><span>{{ header.text }}</span>
          </th>
        </template>

        <!-- Dados das Avaliações -->
        <!-- eslint-disable-next-line  -->
        <template v-slot:item="{ item }">
          <!-- eslint-disable-next-line  -->
          <tr>
            <!-- eslint-disable-next-line  -->
            <td v-for="i in removeUltimoElementoDoObjeto(item)" style="border-bottom: none;">
              <!-- eslint-disable-next-line  -->
              <span>{{ i }}</span>
            </td>
          </tr>

          <!-- Acrescenta gráfico na linha -->
          <!-- eslint-disable-next-line  -->
          <tr>
            <!-- Colocar no colspan o número de avaliações menos o total e a media. x-2 ou x -->
            <td colspan="1" style="text-align: center; height: 15px;"></td>
            <td :colspan="headers.length-3" style="text-align: center; height: 15px;">
              <div id="chart" style="margin-bottom: 10px; margin-top: -5px">
                <apexchart type="bar" height="10" :options="chartOptions" :series="item.series"></apexchart>
              </div>
            </td>
            <td colspan="1" style="text-align: center; height: 15px;"></td>
            <td colspan="1" style="text-align: center; height: 15px;"></td>
          </tr>
        </template>

      </v-data-table>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import {
    mapGetters
  } from 'vuex'

  import {
    registerVuexModule
  } from '@/utils/vuexUtils'

  import relatoriosPesquisaSatisfacaoStore from '../../../store'

  export default {
    props: {
      operadores: Array,
      avaliacoesOperadores: Array,
      idFila: String,
      labels: Array,
    },

    components: {
      apexchart: VueApexCharts,
    },

    data: () => ({
      noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
      // APEX CHART
      chartOptions: {
        chart: {
          type: 'bar',
          height: 10,
          stacked: true,
          stackType: '100%',
          sparkline: {
            enabled: true
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        yaxis: {
          show: false,
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false,
          },
        },
        xaxis: {
          show: false,
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false
          },
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
          },
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
        }
      },
      // FIM APEX
      headers: [],
      operadoresDados: [],
      metricasPesquisa: [],
      cores: [],

      search: '',
      valores: [],
    }),

    async created() {
      registerVuexModule(this.$store, 'relatoriosPesquisaSatisfacaoStore', relatoriosPesquisaSatisfacaoStore)

      this.mapCores() 
      this.mapLabels()
      this.mapColaboradores()
    },

    methods: {

      buscaTodosCampos(value, search, item) {
        return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search))
      },

      removeUltimoElementoDoObjeto(item) {

        let novoObjeto = {
          ...item
        }

        delete novoObjeto.series

        return novoObjeto;
      },

      graficoDados(valor) {
        let dados = []
        let dado = {}

        let data = valor
        let name = ''
        let color = ''

        for (let i = 1; i < this.headers.length; i++) {
        
          if (this.headers[i].text !== 'Colaborador' && this.headers[i].text !== 'Média' && this.headers[i].text !==
            'Total') {
            color = `${this.headers[i].color}`
            name = `${this.headers[i].text}`,

              dado = {
                name,
                "data": [data[i].amount],
                color
              }
            dados.push(dado)
          }
        }

        return dados
      },
      mapValues(obj) {

        let chavesDoObjeto = []
        let paresDoObjeto = []
        let valoresDoObjeto = []

        chavesDoObjeto = Object.keys(obj)
        paresDoObjeto = Object.entries(obj)

        chavesDoObjeto.sort(function (a, b) {
          let aux1 = ''
          let aux2 = ''

          aux1 = a.split(" - ")[0]
          aux2 = b.split(" - ")[0]

          return aux1 - aux2
        });

        for (let i in chavesDoObjeto) {
          for (let j in paresDoObjeto) {
            if (chavesDoObjeto[i] == paresDoObjeto[j][0]) {
              valoresDoObjeto.push(paresDoObjeto[j][1])
            }
          }
        }
        return valoresDoObjeto

      },

    mapCores() {
      const pesquisa = this.findPesquisaById(this.idFila)
      const metricasPesquisa = Object.values(pesquisa.metricas)
      this.cores = metricasPesquisa.map(metrica => metrica.color)
    },

    mapColaboradores() {
        for (let i = 0; i < this.operadores.length; i++) {
          let valoresOperador = this.mapValues(this.avaliacoesOperadores[i])
          // console.log(valoresOperador, "valoresOperador")
          // console.log(this.operadores, "this.operadores")
          valoresOperador.unshift(this.operadores[i])
          this.valores.push(valoresOperador)
        }
      },
    
      mapLabels() {
          this.headers[0] = {
            text: 'Colaborador',
            value: 'Colaborador',
            color: '#FFF'
          }

          this.labels.forEach((label, key) => {
            if (typeof this.headers[key + 1] === 'undefined') {
              this.headers[key + 1] = {}
            }
            this.headers[key + 1].text = label
            this.headers[key + 1].value = label
            if (this.headers[key + 1].value == "Total" || this.headers[key + 1].value == "Média") {
              this.headers[key + 1].color = "#FFF"
            } else if (this.headers[key + 1].value == "Inválida") {
              this.headers[key + 1].color = "#717171"
            } else {
              this.headers[key + 1].color = this.cores[key]
            }
          })
        },

    },

    computed: {
      ...mapGetters('relatoriosPesquisaSatisfacaoStore', ['findPesquisaById']),

      avaliacaoGeralDados() {
        let avaliacaoGeralDados = []
        // for (let i = 0; i < (this.valores.length) / 2; i++) {
        //   delete this.valores[i]
        // }

// console.log(this.valores, "this.valores")
        this.valores.forEach(valor => {
          let dados = {}
          let series = []
          for (let i = 0; i < valor.length; i++) {
            let valorEmPorcentagem = 0
            if (this.headers[i].text === 'Colaborador') {
              dados[0] = `${valor[i]}`
            } else if (this.headers[i].text === 'Média' || this.headers[i]
              .text === 'Total') {
              dados[this.headers[i].text] = `${valor[i]}`
            } else {
              if (valor[i].amount > 0) {
                valorEmPorcentagem = (Math.round(((valor[i].amount) / valor[valor.length - 2]) * 100) * 10) / 10
              } else {
                valorEmPorcentagem = 0
              }
              dados[this.headers[i].text] = `${valor[i].amount} (${valorEmPorcentagem})%`
            }
          }
          series = this.graficoDados(valor)
          dados = {
            ...dados,
            series
          }
          avaliacaoGeralDados.push(dados)
        })

        // console.log(avaliacaoGeralDados, "avaliacaoGeralDados")
        return avaliacaoGeralDados
      },
    },

  }
</script>
<style lang="scss" scoped>
  tbody {
    tr:hover {
      background-color: transparent !important;
    }
  }

  .tamanhoDoQuadrado {
    font-size: 35px;
  }
</style>